// src/hooks/useCurrency.ts
import { useEffect, useState } from 'react';
import { getSuggestedCurrency } from '../utils/getSuggestedCurrency';

type SupportedCurrency = 'EUR' | 'USD' | 'AED' | 'JPY' | 'QAR';

const useCurrency = () => {
  const [currency, setCurrency] = useState<SupportedCurrency>('EUR');
  const [ready,    setReady]    = useState(false);

  useEffect(() => {
    getSuggestedCurrency()
      .then(c => setCurrency(c as typeof currency))
      .finally(() => setReady(true));
  }, []);

  return { currency, ready };
};

export default useCurrency;
